<template>
  <section>
    <section class="hero is-light">
      <div class="hero-body">
        <div class="container">
          <div class="columns">
            <div class="column">
              <h1 class="title">Usuarios</h1>
              <h2 class="subtitle">Lista de Usuarios con permisos</h2>
            </div>
            <div class="column">
              <div class="field">
                <div class="control has-icons-left has-icons-right">
                  <input class="input is-large" type="text" v-model="search" placeholder="Buscar">
                  <span class="icon is-medium is-left">
                    <i class="material-icons">search</i>
                  </span>
                  <span class="icon is-medium is-right">
                    <i class="fas fa-check fa-lg"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section">
      <div class="container">
        <table class="table">
          <thead>
            <tr>
              <th></th>
              <th>Usuario</th>
              <th>Permisos</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in filteredItems" :key="user.$index">
              <td>
                <figure class="image is-48x48">
                  <img :src="user.photoURL" class="is-rounded">
                </figure>
              </td>
              <td>
                <h5 class="title is-5">{{user.displayName}}</h5>
                <h6 class="subtitle is-6">{{user.email}}</h6>
              </td>
              <td></td>
              <td>
                <router-link
                  :to="{ name: 'edituser', params: { id: user._id } }"
                  class="button is-light is-rounded"
                >
                  <i class="material-icons">edit</i>
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </section>
</template>


<script>
import { mapState } from "vuex";
import apiServices from "@/services/yungol-services";
const filterItems = (query, data) => {
  return data.filter(el => {
    const texto = el.displayName + el.email;
    if (texto.toLowerCase().indexOf(query.toLowerCase()) > -1) {
      return el;
    }
  });
};
export default {
  data() {
    return {
      users: [],
      search: ""
    };
  },
  computed: {
    ...mapState(["idtoken"]),
    filteredItems: function() {
      return filterItems(this.search, this.users);
    }
  },

  created() {
    async function traeData(_this) {
      let result;
      try {
        result = await apiServices.get(`/users`);
        _this.users = result.data;
      } catch (err) {
        console.log(err);
      }
    }
    traeData(this);
  }
};
</script>
<style lang="scss" scoped>
</style>





// WEBPACK FOOTER //
// src/components/admin/Users.vue